import React, { useState } from 'react';

//boostrap
import { Button } from "reactstrap";

//components
import { ModalViewMedia } from '.';

function ViewMediaButton(props) {

    //state
    const [modal, setModal] = useState({
        viewMedia: false
    });

    const toggle = (type) => {
        setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
    };

    return (
        <div className="mt-4 mx-auto">
            <Button
                className="btn-warning text-1 justify-content-center px-2 mx-1"
                onClick={() => toggle("viewMedia")}
                color="warning"
            >
                View Media
            </Button>
            <ModalViewMedia
                {...props}
                isOpen={modal?.viewMedia}
                toggle={() => toggle("viewMedia")}
            />
        </div>
    );
};

export default ViewMediaButton;